import { DisplayCurrencyType } from '@fullstory/proto/fs/services/webber/frontend/display';
import { RevenueEventResponse } from '@fullstory/proto/fs/services/webber/conversions';
import { int64 } from '@fullstory/proto/google/protobuf';

export const REVENUE_EVENT_RESPONSE: RevenueEventResponse = {
  revenueEvent: {
    id: 'revenueEvent' as int64,
    definedEventId: 'definedEvent',
    eventProperty: 'price',
    currency: DisplayCurrencyType.CURRENCY_USD,
    disabled: false,
  },
};
